export function formatBookingContact(booking) {
  const name = String(booking?.contact_name || "").trim();
  const phone = String(booking?.contact_phone || "").trim();
  if (name && phone) return `${name} • ${phone}`;
  if (name) return name;
  if (phone) return phone;
  return booking?.contact_id || "-";
}

export function bookingContactSearchHaystack(booking) {
  return [
    booking?.contact_id,
    booking?.contact_name,
    booking?.contact_phone,
  ]
    .filter(Boolean)
    .join(" ")
    .toLowerCase();
}
